module.exports = __webpack_public_path__ + "static/img/avatar_r_20.122cbed3.png";